module.exports = __webpack_public_path__ + "media/fonts/suisse-intl/SuisseIntl-Medium-WebS-b80ef62747b688a04da73995b7db6f0d.woff2";